<template>
  <div>
    <DxPopup
      v-if="isPopUpEnabled"
      :visible="isPopupVisible"
      :close-on-outside-click="true"
      :show-close-button="true"
      :drag-enabled="false"
      :show-title="true"
      :wrapper-attr="{ class: 'custom-tutorial-popup' }"
      width="auto"
      height="auto"
      container=".dx-viewport"
      @hiding="hide"
    >
      <div class="popup-content">
        <div class="novelty-badge">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100"
              height="100"
              viewBox="0 0 168 168"
              fill="none"
            >
              <circle cx="84" cy="84" r="84" fill="#DCEDB6" />
              <path
                d="M84 42L94.68 67.32L122 70.68L102 90.36L107.36 118L84 104.4L60.64 118L66 90.36L46 70.68L73.32 67.32L84 42Z"
                fill="#00346A"
              />
            </svg>
          </span>
        </div>

        <h2 class="popup-heading">
          {{ infoMessage }}
        </h2>

        <f7-button
          class="btn-succes whiteFontColor cta-button"
          fill
          outline
          type="default"
          @click="openVideoPopup"
        >
          {{ $t('seeHowItDone') }}
        </f7-button>
      </div>
    </DxPopup>
  </div>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import EventBus from '@/services/event-bus';
import { mapState, mapActions, mapGetters } from 'vuex';
import { ENABLE_INFO_POPUP, IS_LOCAL_TEST } from '@/js/constants';

export default {
  components: { DxPopup },
  data() {
    return {
      isPopupVisible: false,
      delayTime: 3000,
    };
  },
  computed: {
    ...mapState('user', ['authenticatedUser', 'userName']),
    ...mapState('videoPeriodModule', ['currentVideo']),
    ...mapGetters('videoPeriodModule', ['hasRemainingShows']),
    isPopUpEnabled() {
      return ENABLE_INFO_POPUP;
    },

    infoMessage() {
      const name = this.currentVideo?.name || '';
      switch (name) {
        case 'Registro de muestras':
          return this.$t('registerSamplesInfo');
        case 'Registro de incidencias':
          return this.$t('complaintManagementInfo');
        default:
          return this.$t('defaultError');
      }
    },
  },
  watch: {
    currentVideo: {
      immediate: true,
      async handler(v) {
        if (!this.isPopUpEnabled) {
          this.isPopupVisible = false;
          return;
        }

        if (!v) return;
        await this.initFromCookie();
        if (this.hasRemainingShows) {
          setTimeout(() => {
            this.isPopupVisible = true;
          }, this.delayTime);
        }
      },
    },
  },
  created() {
    if (this.userName) this.setActiveUserEmail(this.userName);
  },
  methods: {
    hide() {
      this.isPopupVisible = false;
      this.incrementShowCount();
    },
    openVideoPopup() {
      // Si estamos en  entorno local de pruebas, no se registra el evento
      if (!IS_LOCAL_TEST) {
        const language =
          this.authenticatedUser?.language_code ||
          this.authenticatedUser?.contacts?.[0]?.language;
        window.gtag?.('event', 'tutorial_video_open', {
          video_name: this.currentVideo?.name || 'unknown',
          video_language: language || undefined,
        });
      }
      this.isPopupVisible = false;
      EventBus.$emit('show-video-popup', true);
    },
    ...mapActions('videoPeriodModule', [
      'incrementShowCount',
      'initFromCookie',
      'setActiveUserEmail',
    ]),
  },
};
</script>

<style lang="scss">
@import './newsInfoPopUp.styles.scss';
</style>
